import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-cream border-y border-mist" data-id="element-57" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-58" data-mp="1cfjfca18ywsk">
        <div className="text-center mb-16" data-id="element-59" data-mp="1ccnd49id9lyb">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand" data-id="element-60" data-mp="2a2i9oe4gvsna">❓ Frequently Asked Questions</h2>
        </div>
        <div className="space-y-4" data-id="element-61" data-mp="253ow6lp6k1n4">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-ivory border border-mist rounded-xl overflow-hidden" data-id="element-62" data-mp="20319gc7zi6yp" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-63" data-mp="1v3y2gm8g1qo3">
                <span className="font-bold text-lg text-brand pr-8" data-id="element-64" data-mp="1klvyk5xittze">{faq.q}</span>
                <ChevronDown className={`text-gold-dark transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-65" data-mp="1pkqpjv5n6oul" />
              </button>
              <AnimatePresence initial={false} data-id="element-66" data-mp="11vny5vl7hhmw">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-67" data-mp="16oqsw71pyx4o">
                    <div className="px-6 pb-5 text-ink/75 border-t border-mist pt-4" data-id="element-68" data-mp="iz68djpx3rta">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}